import React from 'react';

const ImpactMessage = () => {

  return (
    <React.Fragment>
      <h2>Your donation makes a big difference</h2>
      <p>
        Your generosity helps local projects continue providing essential support to people facing poverty and injustice, here in the UK and around the world.
      </p>
      <div>
        <a href="https://www.comicrelief.com/your-impact" className="btn btn--red">
          Read More
        </a>
      </div>
    </React.Fragment>
  );
};

export default ImpactMessage;
